const Dynpack = require('od-apps/app.dynpack');
const widgetsAsync = Odigeo.autoloadWidgetsAsync({
    getSearchManager: ['dpsearch-manager', 'dpsearchmanager'],
});

function navigateHome() {
    Odigeo.trigger('dpsearch-manager:navigateHome');
}

function prepareLaunchSearch(params) {
    Odigeo.trigger('dpsearch-manager:prepareLaunchSearch', Dynpack.searchParamsParser(params));
}

function showErrorMessages(params) {
    Odigeo.trigger('dpsearch-manager:checkAndShowErrorMessages', params);
}

function finishLoadingPage() {
    Odigeo.trigger('dpsearch-manager:onFinishLoadingPage');
}

function checkErrors(params) {
    var parsedParams = Odigeo.Utils.parseHashParameters(params);

    if (parsedParams.backEndError || !Odigeo._.isEmpty(parsedParams.errorKey)) {
        showErrorMessages(parsedParams);
        finishLoadingPage();
    } else {
        navigateHome();
    }
}

function launchSearch(params, page, cbErrorGetSearchData, typeSearch = 'search') {
    Dynpack.getSearchData(params, page).then(function(searchParams) {
        if (!Odigeo._.isEmpty(searchParams.searchSegments) && Odigeo._.has(searchParams, 'type')) {
            prepareLaunchSearch(params);
            widgetsAsync.getSearchManager().execute(typeSearch, searchParams);
        } else {
            checkErrors(params);
        }
    }, cbErrorGetSearchData);
}

module.exports = {
    launchSearch: launchSearch,
};
